function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableShopicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8390"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4056"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35789",
    d: "M1935.665 2429.38a6.707 6.707 0 0 1-.473 1.3 4.18 4.18 0 0 1-1.53 1.516.488.488 0 0 1-.291.219 3.926 3.926 0 0 1-4.446-1.007.9.9 0 0 1-.2-.315c-.166-.926-.226-1.865-.329-2.8a.374.374 0 0 1 .031-.182.2.2 0 0 1 .08-.087.96.96 0 0 1 .429-.056h6.333a1.381 1.381 0 0 1 .278.028c.1.063.008.205.115.264z",
    transform: "translate(-1903.666 -2417.94)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35790",
    d: "M1660.509 2468.062a3.859 3.859 0 0 0 4.869 1.063v15.109a2.193 2.193 0 0 1-.708.035c-.572.008-1.145-.011-1.717.009-.268.01-.354-.1-.358-.341v-12.584c-.01-.344-.035-.377-.378-.377q-3.513-.005-7.026 0c-.348 0-.385.041-.386.406v12.273c0 .617 0 .617-.614.617h-16.487a.692.692 0 0 1-.367-.032v-14.975c0-.052.007-.1.01-.155.144-.064.262.025.383.072a3.745 3.745 0 0 0 4.29-.955c.071-.073.127-.166.237-.193.2.032.276.21.4.33a3.727 3.727 0 0 0 4.612.575 3.5 3.5 0 0 0 .84-.689.366.366 0 0 1 .221-.161c.25.062.374.286.547.441a3.69 3.69 0 0 0 5.1-.127 1.436 1.436 0 0 1 .42-.363c.121 0 .183.082.252.159a3.734 3.734 0 0 0 5.519.137c.091-.105.153-.275.341-.274z",
    transform: "translate(-1635.381 -2454.871)",
    style: {
      fill: "#8cd2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35791",
    d: "m1663.1 2333.585-.021.062a.6.6 0 0 1-.3.041h-5.068a1.118 1.118 0 0 1-.46-.052.334.334 0 0 1-.148-.19.7.7 0 0 1-.035-.246c.032-.842-.07-1.681-.075-2.523 0-.7-.072-1.39-.058-2.086 0-.233-.1-.338-.34-.338h-4.709c-.23 0-.319.1-.309.321.037.791-.061 1.577-.074 2.367a63.434 63.434 0 0 1-.078 2.179c-.073.161 0 .366-.151.5a.753.753 0 0 1-.4.065h-4.995a1 1 0 0 1-.339-.038.231.231 0 0 1-.094-.071 1.337 1.337 0 0 1 .01-.707q.217-2.112.452-4.221c.04-.359.01-.4-.355-.4-1.52 0-3.04 0-4.559-.005-.182 0-.34.083-.516.094 0-.854.009-1.707 0-2.561 0-.247.068-.318.316-.317 2.217.009 4.435.005 6.652.005h20.112c.411 0 .411 0 .412.4v1.905a1.048 1.048 0 0 0 .054.4.724.724 0 0 1-.481.081h-4.455c-.446 0-.461.024-.414.458.163 1.517.323 3.034.488 4.551a.4.4 0 0 1-.062.326z",
    transform: "translate(-1638.281 -2323.46)",
    style: {
      fill: "#1359d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35792",
    d: "M1637.353 2517.715c.094 0 .187.007.281.007q8.354 0 16.709.007c.3 0 .382-.063.381-.372q-.016-6.293-.007-12.586c0-.411 0-.411.424-.411 2.4 0 4.81.006 7.215-.008.309 0 .373.089.372.383-.01 4.206 0 8.412-.014 12.618 0 .3.075.387.377.376.769-.025 1.54-.014 2.31-.018-.086.114-.211.068-.319.068h-27.408c-.108 0-.232.044-.321-.064z",
    transform: "translate(-1635.402 -2488.349)",
    style: {
      fill: "#f4f6f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35793",
    d: "m1922.693 2365.083-.565-5.067c-.042-.38-.04-.383.34-.383h4.8c.113 0 .226.02.339.03l2.043 5.052c.039.1.068.2.1.293-.085.113-.209.074-.318.074q-3.367.003-6.739.001z",
    transform: "translate(-1897.871 -2354.958)",
    style: {
      fill: "#04498b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35794",
    d: "M1616.135 2359.767c.059-.177.189-.207.362-.206 1.641.006 3.283.009 4.924 0 .249 0 .3.083.276.305-.124 1.049-.241 2.1-.357 3.148-.075.669-.145 1.338-.217 2.008a.541.541 0 0 1-.413.1h-6.209c-.155 0-.368.073-.438-.173l1.476-3.669.596-1.513z",
    transform: "translate(-1613.934 -2354.889)",
    style: {
      fill: "#04498b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35795",
    d: "M1612.558 2428.315c.106.128.252.073.38.074q3.34.006 6.679 0l.026-.006a.336.336 0 0 1 .057.238c-.091.869-.176 1.738-.292 2.6a.337.337 0 0 1-.094.225 3.871 3.871 0 0 1-3.384 1.495 4.516 4.516 0 0 1-1.541-.449 4.089 4.089 0 0 1-1.606-1.771 3.427 3.427 0 0 1-.225-2.406z",
    transform: "translate(-1612.43 -2418.264)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35796",
    d: "M1853.159 2429.259h5.471a.639.639 0 0 1 .392.06l.325 3a3.8 3.8 0 0 1-3.135 1.494 3.689 3.689 0 0 1-2.846-1.37c-.04-.047-.086-.088-.13-.132a.318.318 0 0 1-.1-.281c.008-.809-.111-1.614-.067-2.424a.484.484 0 0 1 .09-.347z",
    transform: "translate(-1834.221 -2419.132)",
    style: {
      fill: "#2973f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35797",
    d: "M1678.125 2513.741c-2.1 0-4.205 0-6.308.005-.27 0-.372-.048-.37-.351q.019-4.341 0-8.681c0-.285.086-.341.353-.341q6.324.012 12.647 0c.276 0 .376.059.375.359q-.017 4.341 0 8.681c0 .256-.062.334-.326.333-2.124-.009-4.248-.005-6.371-.005z",
    transform: "translate(-1666.826 -2488.37)",
    style: {
      fill: "#f4f6f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35798",
    d: "M1782.555 2423.978c-.033 1.02.072 2.037.077 3.056a3.769 3.769 0 0 1-3.376 1.5 3.716 3.716 0 0 1-2.519-1.262c-.055-.06-.116-.116-.175-.174a.408.408 0 0 1-.1-.316c-.045-.849.083-1.694.066-2.543a.363.363 0 0 1 .092-.258c.034-.148-.018-.307.054-.451.125.328.382.361.7.358 1.474-.013 2.947-.007 4.421 0a4.559 4.559 0 0 0 .714-.044z",
    transform: "translate(-1763.615 -2413.851)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35799",
    d: "m1706.506 2429.247-.071 2.744c0 .124.007.249.01.373a3.864 3.864 0 0 1-1.881 1.269 3.757 3.757 0 0 1-4.1-1.231l-.083-.092.329-3.067z",
    transform: "translate(-1693.498 -2419.119)",
    style: {
      fill: "#2973f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35800",
    d: "M1785.128 2364.895c-.027.162-.152.141-.265.141-1.746 0-3.492-.009-5.238.007-.386 0-.3-.247-.326-.458.048-1.589.1-3.178.142-4.768 0-.169.054-.237.234-.237q2.526.008 5.052 0c.238 0 .241.136.247.3.021.592.043 1.184.061 1.776q.049 1.618.093 3.239z",
    transform: "translate(-1766.238 -2354.909)",
    style: {
      fill: "#04498b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35801",
    d: "M1878.712 2598.41c.79 0 1.58.009 2.37-.006.238 0 .3.07.293.3q-.015 2.043 0 4.086c0 .221-.04.309-.287.307q-2.4-.017-4.8 0c-.223 0-.279-.071-.277-.284.008-1.373.01-2.745 0-4.117 0-.245.081-.292.3-.289.799.011 1.6.003 2.401.003z",
    transform: "translate(-1855.375 -2575.04)",
    style: {
      fill: "#c0c2c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35802",
    d: "M1878.73 2521.718c.8 0 1.6.006 2.4 0 .206 0 .267.061.266.265q-.011 2.074 0 4.148c0 .2-.061.274-.266.273q-2.417-.009-4.835 0c-.207 0-.266-.074-.265-.274q.01-2.074 0-4.148c0-.2.062-.267.267-.264.811.007 1.622 0 2.433 0z",
    transform: "translate(-1855.396 -2504.352)",
    style: {
      fill: "#c0c2c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35803",
    d: "M1693.729 2521.709c1.675 0 3.35 0 5.025-.005.24 0 .318.056.316.309q-.015 3.043 0 6.086c0 .235-.065.3-.3.3q-5.056-.011-10.112 0c-.215 0-.285-.055-.284-.278q.012-3.059 0-6.117c0-.235.065-.3.3-.3 1.684.009 3.369.005 5.055.005z",
    transform: "translate(-1682.43 -2504.343)",
    style: {
      fill: "#c0c2c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35804",
    d: "M1753.578 2531.095a.532.532 0 0 1-.181.435l-4.021 4.018a.614.614 0 0 1-.821.081.641.641 0 0 1-.207-.854 1.1 1.1 0 0 1 .224-.3q1.867-1.865 3.733-3.732a.8.8 0 0 1 .735-.311.6.6 0 0 1 .538.663z",
    transform: "translate(-1737.633 -2512.38)",
    style: {
      opacity: 0.3,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35805",
    d: "M1785.028 2565.03a.652.652 0 0 1-.257.545q-.588.6-1.189 1.191a.645.645 0 0 1-.984.06.655.655 0 0 1 .061-1.01c.41-.413.819-.826 1.235-1.233a.646.646 0 0 1 .769-.147.585.585 0 0 1 .365.594z",
    transform: "translate(-1769.086 -2543.667)",
    style: {
      opacity: 0.3,
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableShopicon);
export default __webpack_public_path__ + "static/media/TableShopicon.c8ab7b9cd451d3141dc6888fc6a309e3.svg";
export { ForwardRef as ReactComponent };